
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnItemsGrid extends Serenity.EntityGrid<PurchaseReturnItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseReturnItems'; }
        protected getDialogType() { return PurchaseReturnItemsDialog; }
        protected getIdProperty() { return PurchaseReturnItemsRow.idProperty; }
        protected getInsertPermission() { return PurchaseReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseReturnItemsRow.localTextPrefix; }
        protected getService() { return PurchaseReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}